import {setWebShare, setPageTitle, queryString, fetch, toast, statistics} from '@/utils/'
import API from '@/api/api'

import DEFAULT_HEADER_BACKGROUND from '@/assets/images/preload.png'
const DEFAULT_SHARE_IMAGE = 'http://shuocdn.108sq.cn/frontEnd/wap/images/new/logo_60_60_new.png'
// 头图的显示比例
var ratio = 28 / 75
// 整个帖子的id
var pageId = queryString('id')

// 整个直播的信息，包括头图，以及分享信息
export default {
  state: {
    ratio,
    pageInfo: {
      Title: 'Live',
      HeaderImageUrl: DEFAULT_HEADER_BACKGROUND,
      ShareImageUrl: DEFAULT_SHARE_IMAGE,
      PresenterId: 0,
      PrensenterName: '',
      PostId: 0
    },
    shareInfo: {
      title: '',
      titleUrl: window.location.href,
      content: '',
      imageUrl: ''
    }
  },

  actions: {
    getPageInfo ({commit, dispatch}) {
      fetch({
        url: API.GET_PAGE_INFO(pageId)
      })().then(response => {
        response = JSON.parse(response)
        if (response.State === 1) {
          commit('PAGE_INIT', response.Result)
          commit('SHARE_INFO_INIT', response.Result)
          dispatch('initEliteList')
          dispatch('getAllListInfo')
          // 埋点
          statistics('View', response.Result.PostId)
        }
      }).catch(error => {
        toast('网络错误')
        throw new Error(error)
      })
    }
  },

  mutations: {
    PAGE_INIT (state, info) {
      state.pageInfo = info
      setPageTitle(info.Title)
    },

    SHARE_INFO_INIT (state, info) {
      state.shareInfo.title = info.Title
      state.shareInfo.content = info.Title
      state.shareInfo.imageUrl = info.ShareImageUrl
      setWebShare(state.shareInfo)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/module/header.js